<template>
  <vue-bottom-sheet :background-clickable="false"
                    :background-scrollable="false"
                    :click-to-close="canSwipe"
                    :is-full-screen="true"
                    :maxHeight="mobile ? '80%' : '65%'"
                    :maxWidth="mobile ? '100%' : '95%'"
                    :overlay="true"
                    :rounded="true"
                    :swipe-able="canSwipe"
                    ref="methodSheet">
    <PaymentMethods :set-swipe="setSwipe" />
  </vue-bottom-sheet>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import PaymentMethods from "@/components/point-of-sale/sales/payment/PaymentMethods";

export default {
  name: "MethodsBottomSheet",
  components: {PaymentMethods, VueBottomSheet},
  data() {
    return {
      canSwipe: true,
      mobile: false
    }
  },
  methods: {
    close() {
      try {
        this.$refs.methodSheet.close();
      } catch (e) {
        console.error(e);
      }
    },

    setSwipe() {
      this.canSwipe = !this.canSwipe
    },

    open() {
      try {
        this.$refs.methodSheet.open();
      } catch (e) {
        console.error(e)
      }
    },

    checkScreenSize() {
      this.mobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }
}
</script>

<style lang="scss" scoped>
:deep(.vue-bottom-sheet) {
  @media (max-width: 768px) {
    border-radius: 20px 20px 0 0;
  }
}

:deep(.vue-bottom-sheet-content) {
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
}
</style>
